import { type SVGProps } from 'react'

type PinIconProps = {
  variant?: 'default' | 'fullfield' | 'unpin'
} & SVGProps<SVGSVGElement>

export default function PinIcon({
  variant = 'default',
  ...props
}: PinIconProps) {
  if (variant === 'unpin') {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
      >
        <path
          d="M13 1V2.5H12V8.89583L5.625 2.52083L5 1.875V1H13ZM9 17L8.25 16.25V11.5H4V10L6 8V7.125L0.875 2L1.9375 0.9375L16.0625 15.0833L15 16.1458L10.375 11.5H9.75V16.25L9 17Z"
          fill="currentColor"
        />
      </svg>
    )
  }

  if (variant === 'fullfield') {
    return (
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
      >
        <path
          d="M8 7L10 9V10.5H5.75V15.25L5 16L4.25 15.25V10.5H0V9L2 7V1.5H1V0H9V1.5H8V7Z"
          fill="currentColor"
        />
      </svg>
    )
  }

  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M8 7L10 9V10.5H5.75V15.25L5 16L4.25 15.25V10.5H0V9L2 7V1.5H1V0H9V1.5H8V7ZM2.125 9H7.875L6.5 7.625V1.5H3.5V7.625L2.125 9Z"
        fill="currentColor"
      />
    </svg>
  )
}
